module.exports = __webpack_public_path__ + "assets/img/btn_rule.7e0a0f84.png";